import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Template1Component } from './template1/template1.component';
import { Template2Component } from './template2/template2.component';
import { Template3Component } from './template3/template3.component';

const routes: Routes = [
  {
    path: 'template-1/:businessCardId',
    component: Template1Component,
  },
  {
    path: 'template-2/:businessCardId',
    component: Template2Component,
  },
  {
    path: 'template-3/:businessCardId',
    component: Template3Component,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BusinessCardRoutingModule {}
